var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconcheckboxunselected = function SvgIconcheckboxunselected(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icon.checkbox.unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icon.checkbox.unselected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visibility",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56-2",
    stroke: "#09BE86",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.398,7.703 C16.5915995,7.50899356 16.8544211,7.39996759 17.1285,7.39996759 C17.4025789,7.39996759 17.6654005,7.50899356 17.859,7.703 C18.051774,7.88664148 18.160875,8.14125576 18.160875,8.4075 C18.160875,8.67374424 18.051774,8.92835852 17.859,9.112 L10.859,16.103 C10.4560326,16.5057089 9.80296743,16.5057089 9.4,16.103 L6.459,13.114 C6.26532126,12.9304456 6.15562078,12.6753402 6.15562078,12.4085 C6.15562078,12.1416598 6.26532126,11.8865544 6.459,11.703 C6.86196743,11.3002911 7.51503257,11.3002911 7.918,11.703 L10.159,13.894 L16.398,7.703 Z",
    id: "Path_420"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconcheckboxunselected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.checkbox.unselected.f7cbca1858773616b67ed6225e70c9ad.svg";